module.exports = __webpack_public_path__ + "static/media/book.4d90b3c8.jpg";